/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Shopping_AddedInputs */

const en_recipe_shopping_added = /** @type {(inputs: Recipe_Shopping_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On the shopping list`)
};

const de_recipe_shopping_added = /** @type {(inputs: Recipe_Shopping_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steht auf der Einkaufsliste`)
};

/**
* | output |
* | --- |
* | "On the shopping list" |
*
* @param {Recipe_Shopping_AddedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_shopping_added = /** @type {((inputs?: Recipe_Shopping_AddedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Shopping_AddedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_shopping_added(inputs)
	return en_recipe_shopping_added(inputs)
});